import _ from 'lodash';
import disableEventsModal from '../../admin/equipment/disableEvents.modal.component';
import template from './weatherPanel.html';


export default {
  name: 'weatherPanel',
  template,
  controller: WeatherPanelController,
  bindings: {
    panelId: '<'
  }
};

/* @ngInject */
function WeatherPanelController(
  $scope,
  growl,
  $uibModal,
  EquipmentInfoService,
  WeatherPanelService,
  DashboardService,
  $interval,
  $timeout,
  uiGridConstants,
  weatherGridFactory
) {

  /**
   * Private Variables
   */
  const vm = this;
  let getHoursInterval;
  let handlePanelResizeTimeout;
  let maxRowsSelectable = 10;
  const milliMinute = 60000;
  const resizeMilli = 350;

  /**
   * Public Variables
   */
  vm.weatherPanelModel = {};
  vm.loadingSpinners = {};
  vm.editPanel = {
    needsToBeConfigured: false
  };
  vm.disableButtonActive = false;
  vm.selectedEquipment = [];


  /**
   * Public Methods
   */
  vm.$onInit = init;
  vm.$postLink = postLink;
  vm.$onDestroy = handleDestroy;
  vm.disableEvents = disableEvents;
  vm.deleteModel = deleteModel;
  vm.handleNewEvent = handleNewEvent;
  vm.handleDestroy = handleDestroy;
  vm.handlePanelResizeEvent = handlePanelResizeEvent;

  function init() {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];
    vm.equipmentGrid = weatherGridFactory(sortEventCounts);
    vm.equipmentGrid.appScopeProvider = vm;
    vm.equipmentGrid.onRegisterApi = (gridApi) => {
      vm.gridApi = gridApi;

      gridApi.selection.on.rowSelectionChanged(null, handleRowSelectionChange);
      gridApi.selection.on.rowSelectionChangedBatch(null, handleRowSelectionChange);

      function handleRowSelectionChange(rows) {
        // limit number of selected rows
        if (vm.gridApi.selection.getSelectedCount() > maxRowsSelectable) {
          if (!_.isArray(rows)) {
            rows = [rows];
          }
          growl.warning(`A max of ${maxRowsSelectable
          } items selectable at one time. Reverting recent selection(s).`);
          _.forEach(rows, (row) => {
            row.setSelected(false);
          });
        }

        vm.selectedEquipment = vm.gridApi.selection.getSelectedRows();
        vm.disableButtonActive = vm.selectedEquipment.length > 0;
      }
    };
    configurePanel();
  }

  function postLink() {
    $scope.$on('panel-resized', () => {
      vm.handlePanelResizeEvent();
    });
  }

  function configurePanel() {
    if (vm.panel.equipment && vm.panel.equipment.length) {
      // panel is good to go
      vm.loadingSpinners.stopWeatherPanel = false;
      vm.editPanel.needsToBeConfigured = false;

      setupEventListeners();

      if (_.has(vm.panel, 'config.maxRowsSelectable') && vm.panel.config.maxRowsSelectable) {
        maxRowsSelectable = vm.panel.config.maxRowsSelectable;
      }
      return WeatherPanelService.getWeatherPanelModel(vm.panel.equipment, vm.panel)
        .then((weatherPanelModel) => {
          vm.weatherPanelModel = weatherPanelModel;
          vm.equipmentGrid.data = weatherPanelModel.equipment;
          startGetHoursInterval();
        })
        .finally(() => {
          vm.loadingSpinners.stopWeatherPanel = true;
        });
    }
    // panel needs to be configured
    vm.loadingSpinners.stopWeatherPanel = true;
    vm.editPanel.needsToBeConfigured = true;

    return true;
  }

  function disableEvents(equipment) {
    const modalInstance = $uibModal.open({
      ...disableEventsModal,
      size: 'lg',
      resolve: {
        selectedEquipment() {
          return equipment;
        }
      }
    });

    modalInstance.result
      .then((updatedEquipment) => {
        _.forEach(updatedEquipment, (updatedEq) => {
          EquipmentInfoService.getHoursRemaining(updatedEq);
          EquipmentInfoService.updateEquipment(updatedEq);
        });
        vm.gridApi.selection.clearSelectedRows();
        vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.EDIT);
        vm.disableButtonActive = false;
      });
  }

  function sortEventCounts(aa, bb) {
    const countA = vm.weatherPanelModel.eventCounter[aa];
    const countB = vm.weatherPanelModel.eventCounter[bb];
    if (countA && countB) {
      return countA - countB;
    } else if (!countA && !countB) {
      return 0;
    } else if (countA) {
      return 1;
    }
    return -1;
  }

  function startGetHoursInterval() {
    getHoursInterval = $interval(() => {
      _.forEach(vm.weatherPanelModel.equipment, (eq) => {
        if (eq.disable?.status) {
          EquipmentInfoService.getHoursRemaining(eq);
        }
      });
      vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.EDIT);
    }, milliMinute);
  }

  function deleteModel() {
    WeatherPanelService.deleteModel(vm.panel.id);
  }

  // TODO: Remove unused parameter
  function handleNewEvent(__, eventObj) {
    if (_.has(vm.weatherPanelModel.eventCounter, eventObj.equipment.id)) {
      vm.weatherPanelModel.eventCounter[eventObj.equipment.id] += 1;
      vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.EDIT);
    }
  }

  function handleDestroy() {
    if (angular.isDefined(getHoursInterval)) {
      $interval.cancel(getHoursInterval);
      getHoursInterval = null;
    }
    if (angular.isDefined(handlePanelResizeTimeout)) {
      $timeout.cancel(handlePanelResizeTimeout);
      handlePanelResizeTimeout = null;
    }
    deleteModel();
  }

  function handlePanelResizeEvent() {
    handlePanelResizeTimeout = $timeout(() => {
      vm.gridApi.core.handleWindowResize();
    }, resizeMilli);
  }

  function setupEventListeners() {

    /* New Event Listener */
    _.forEach(vm.panel.equipment, (equipmentId) => {
      $scope.$on(`event:${equipmentId}`, vm.handleNewEvent);
    });
  }
}
